import type { ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * Cartão de escolha do aparelho — alvo grande, porque é a única decisão da tela.
 *
 * Mora aqui, e não dentro de um dos dialogs, porque a pergunta é a mesma em dois
 * lugares: "qual tablet vai ficar na mesa?" (iPad/Android) e "qual aparelho é
 * este totem?" (Windows/Android). Duas cópias divergiriam no primeiro ajuste.
 */
export function BotaoPlataforma({
  icone,
  titulo,
  descricao,
  selo,
  aoEscolher,
}: {
  icone: ReactNode;
  titulo: string;
  descricao: string;
  /** Etiqueta ao lado do título (ex.: "Em breve"). Use `component="span"`: o cartão é um <button>. */
  selo?: ReactNode;
  aoEscolher: () => void;
}): JSX.Element {
  return (
    <Paper
      variant="outlined"
      component="button"
      type="button"
      onClick={aoEscolher}
      sx={{
        flex: 1,
        p: 2,
        borderRadius: 2,
        cursor: 'pointer',
        textAlign: 'left',
        font: 'inherit',
        color: 'inherit',
        bgcolor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        transition: 'border-color 200ms ease, background-color 200ms ease',
        '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
      }}
    >
      {/* Tudo em <span>: o cartão É um <button>, que só aceita conteúdo de
          frase — <div>/<h6> aqui seriam HTML inválido. */}
      <Box component="span" sx={{ color: 'primary.main', display: 'flex' }}>
        {icone}
      </Box>
      <Box component="span" sx={{ minWidth: 0 }}>
        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
          <Typography variant="subtitle1" component="span" sx={{ lineHeight: 1.3 }}>
            {titulo}
          </Typography>
          {selo}
        </Box>
        <Typography variant="caption" color="text.secondary" component="span" sx={{ display: 'block' }}>
          {descricao}
        </Typography>
      </Box>
    </Paper>
  );
}
